<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Laboratory Check-out</h5>



    <br />
    <br />

    <ul>
      <li>Click the relevant field before scanning.</li>
      <li>Press Enter to validate the scanned code.</li>
      <li>Press Esc to clear the form.</li>

    </ul>

    <br />
    <br />

    <form>

      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Click the field below before scanning the QR code. <i class="fa fa-arrow-down"></i>
          </label>
          <input #QRCodeInputUpload type="text" (keyup.enter)="QRCodeInputUpload_Enter()"
            (keyup.esc)="QRCodeInputUpload_Esc()"
            style="font-family: Arial, Helvetica, sans-serif;background-color: #dfdddd;" class="form-control EnglishClm"
            placeholder="Click here...">
          <p [hidden]="!Procssing"> Please wait... <i class="fa fa-spin fa-refresh"></i> </p>

        </div>
      </div>

      <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeChangeUpload()" type="button"
        [disabled]="Info_Upload_List.length==0" class="btn btn-success" style="margin-right: 5px;"><i
          class="fa  fa-plus-circle"></i> Check Out Scanned Instruments </button>

      <button *ngIf="!Procssing && !FormSubmitted" (click)="QRCodeInputUpload_Enter()" type="button"
        class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Validate Instrument ID </button>

      <button *ngIf="!Procssing && FormSubmitted" (click)="ResetForm()" type="button" class="btn btn-danger"
        style="margin-right: 5px;"><i class="fa  fa-recycle"></i> Start Over </button>

      <button *ngIf="inner_UploadDevice_id==0" routerLink="/LabDownloadUploadDevice" type="button"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>

      <button *ngIf="inner_UploadDevice_id>0" (click)="On_Back()" type="button"
        class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
    </form>

    <br />
    <br />

    <div class="row" *ngIf="Info_Upload_List.length>0">
      <div class="form-group col-md-12">
        <div class="table-responsive">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>Title Instrument</th>
                <th>Instrument Code</th>
                <th>Instrument Serial Number</th>
                <th *ngIf="!FormSubmitted">QR Code</th>
                <th *ngIf="FormSubmitted">System Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of Info_Upload_List">
                <td>{{Info_Upload_List.indexOf(item)+1}}</td>
                <td>{{item.userDsc}}</td>
                <td>{{item.code}}</td>
                <td>{{item.title}}</td>
                <td *ngIf="item.id==0">{{item.dsc}}</td>
                <td *ngIf="item.id>0" style="color: green;">{{item.dsc}}</td>
                <td *ngIf="item.id<0" style="color: red;">{{item.dsc}}</td>
                <td>
                  <button *ngIf="!FormSubmitted" (click)="Info_Upload_Remove(Info_Upload_List.indexOf(item))"
                    class="btn btn-danger"><i class="fa fa-remove"></i> Delete </button>
                </td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


  </div>
</div>
